import helper from '../../../helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('portaliPagineOfferte');
export const actions = helper.createActions('portaliPagineOfferte', actionTypes);